<template>
  <div class="collapsible-group" :class="{ collapsed }" @contextmenu.stop.prevent="$emit('contextmenu', $event)">
    <EditorDeckSlidesThreeDLayerListItem
      class="h-10 text-white border border-b-0 border-gray-700 select-none collapsible-group-header"
      :selected="selected"
      :visible="true"
      :selected-in-panel="selected"
      @click.stop.prevent="$emit('collapsible-header-click')"
    >
      <template #visibility>
        <slot name="visibility" :collapsed="collapsed" />
      </template>

      <div :class="['flex items-center', { 'ml-4': type === 'dataset' }]">
        <div class="flex items-center justify-center w-6 h-6 cursor-pointer" @click.prevent.stop="toggleCollapse">
          <FontAwesomeIcon class="close-icon transition duration-200" icon="caret-down" :class="{ collapsed }" />
        </div>
        <span class="flex-grow max-w-xs font-semibold truncate" :title="title" data-testid="collapsible-header-title">
          <slot name="icon" />{{ title }}
        </span>
      </div>
    </EditorDeckSlidesThreeDLayerListItem>

    <div class="collapsible-content" data-testid="collapsible-content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  disabled: {
    type: [Boolean, String],
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
  isCollapsed: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['collapsible-header-click', 'contextmenu', 'click'])

const collapsed = ref(props.isCollapsed)

watch(
  () => props.isCollapsed,
  value => {
    collapsed.value = value
  }
)

function toggleCollapse(e: Event, ...args: any[]) {
  collapsed.value = !collapsed.value
  emit('click', e, ...args)
}
</script>

<style lang="stylus" scoped>
.collapsible-group.collapsed
  .collapsible-group-header
    .close-icon
      @apply transform -rotate-90

  .collapsible-content
    @apply h-0 overflow-hidden

  .collapsible-group-header
    @apply text-white border border-b-0 border-gray-700 text-sm font-medium
</style>
